import { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import ViewDiscountVouchersComponent from "../components/DiscountVouchers/ViewDiscountVouchers";

const DiscountVouchersPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Discount Vouchers");
  }, [setTitle]);
  return (
    <>
      <ViewDiscountVouchersComponent />
    </>
  );
};
export default DiscountVouchersPage;
